<template>
    <v-btn class="ma-2 help-btn" color="blue-lighten-1" icon="mdi-help" />
</template>

<style scoped>
.help-btn {
    font-size: x-small !important;
    height: 25px !important;
    width: 25px !important;
    bottom: 2px;
}
</style>